import React from 'react';
import { forwardRef } from 'react';
import { StyledLabel, StyledInput, StyledTextContent, StyledRadioContainer, StyledRadioIndicator } from './index.styles.js';
import { SYS_SPACE_FIXED_450 } from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { FormMessage } from '../form-message/index.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const RadioButton = forwardRef(({ className, label, id, checked, defaultChecked, value, disabled, name, required, invalid, onChange, errorMessage, onClick, onKeyDown, hint, margin, ...rest }, ref) => {
    const hintId = `${id}__hint`;
    const errorMsgId = `${id}__error-msg`;
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const ariaDescribedBy = hint || (errorMessage && invalid) || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            errorMessage && invalid ? errorMsgId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledRadioContainer, { className: className, ref: ref, margin: margin, ...pickDataProps(rest) },
        React.createElement(StyledLabel, { invalid: invalid },
            React.createElement(StyledInput, { type: "radio", checked: checked, defaultChecked: defaultChecked, id: id, value: value, disabled: disabled, required: required, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, name: name, invalid: invalid, ...pickA11yProps(rest), "aria-describedby": ariaDescribedBy }),
            React.createElement(StyledRadioIndicator, { invalid: invalid }),
            React.createElement(StyledTextContent, null, label)),
        hint && (React.createElement(FormMessage, { text: hint, variant: "hint", id: hintId, disabled: disabled, margin: [0, 0, 0, SYS_SPACE_FIXED_450] })),
        invalid && errorMessage && (React.createElement(FormMessage, { text: errorMessage, variant: "error", id: errorMsgId, margin: [0, 0, 0, SYS_SPACE_FIXED_450] }))));
});
RadioButton.displayName = 'RadioButton';
//# sourceMappingURL=index.js.map